import { useState } from "react";
import Friendrequests from "../../components/friendrequests/Friendrequests";
import Friends from "../../components/friends/Friends";
import Peopleyoumayknow from "../../components/peopleyoumayknow/Peopleyoumayknow";
import "./friendList.scss";

const FriendList = () => {
  const [currentTab, setCurrentTab] = useState("friends");

  return (
    <div className="friendList">
      <div className="friendListTab">
        <button 
          className={`friendListTabItems ${currentTab === "friends" ? "active" : ""}`} 
          onClick={() => setCurrentTab("friends")}
        >
          Friends
        </button>

        <button 
          className={`friendListTabItems ${currentTab === "requests" ? "active" : ""}`}
          onClick={() => setCurrentTab("requests")}
        >
          Friend request
        </button>

        <button 
          className={`friendListTabItems ${currentTab === "suggestions" ? "active" : ""}`}
          onClick={() => setCurrentTab("suggestions")}
        >
          People You May Know
        </button>
      </div>

      <div className="friendListContent">
        {currentTab === "friends" && (
          <div className="tabPane">
            <Friends />
          </div>
        )}

        {currentTab === "requests" && (
          <div className="tabPane">
            <Friendrequests /> 
          </div>
        )}

        {currentTab === "suggestions" && (
          <div className="tabPane">
            <div className="emptyState">
              <Peopleyoumayknow />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default FriendList;